import Breadcrumbs from "../components/Breadcrumbs";
import Footer from "../components/Footer";
import Header from "../components/Header";
import MobileHeader from "../components/MobileHeader";
import MobileFooter from "../components/MobileFooter";
import useIsMobile from "../hooks/useIsMobile";
import "../css/Legal.scss";

function Legal() {
  const isMobile = useIsMobile();

  return (
    <div className="legal-page">
      {isMobile ? <MobileHeader /> : <Header />}
      <Breadcrumbs />
      <h2 className="page-heading">Правовая информация</h2>
      <div className="legal-content">
        <section>
          <h2>Пользовательское соглашение</h2>
          <h3>1. Общие положения</h3>

          <p>
            1.1. Настоящее Пользовательское соглашение (далее — «Соглашение»)
            определяет порядок использования Сайта [указать домен] и регулирует
            отношения между ООО <br /> «Джинова» и пользователем (физическим или
            юридическим лицом), осуществляющим доступ к Сайту и/или оформляющим
            заказ.
          </p>
          <p>
            1.2. Использование Сайта и оформление заказа означают безоговорочное
            согласие пользователя с условиями настоящего Соглашения.
          </p>
        </section>

        <section>
          <h3>2. Условия пользования сайтом</h3>
          <p>2.1. Пользователь обязуется:</p>

          <ul style={{ listStyle: "none", paddingLeft: "0" }}>
            <li>предоставлять достоверную информацию при оформлении заказа;</li>
            <li>
              не предпринимать действий, способных привести к нарушению
              функционирования Сайта;
            </li>
            <li>не использовать Сайт в противоправных целях.</li>
          </ul>
          <p>2.2. ООО «Джинова» вправе:</p>
          <ul style={{ listStyle: "none", paddingLeft: "0" }}>
            <li>
              приостанавливать доступ к Сайту в целях проведения технических
              работ;
            </li>
            <li>вносить изменения в функционал и содержание Сайта;</li>
            <li>
              изменять условия настоящего Соглашения без предварительного
              уведомления.
            </li>
          </ul>
        </section>

        <section>
          <h3>3. Оформление заказа</h3>
          <p>3.1. Оформление заказа на Сайте возможно без регистрации.</p>
          <p>
            3.2. Пользователь самостоятельно несет ответственность за полноту и
            достоверность данных, указанных при заказе.
          </p>
          <p>
            3.3. Подтверждая заказ, пользователь соглашается с условиями
            обработки персональных данных.
          </p>
        </section>

        <section>
          <h3>4. Интеллектуальная собственность</h3>
          <p>
            4.1. Все объекты, размещенные на Сайте (дизайн, текст, графика,
            логотипы и др.), являются объектами исключительных прав ООО
            «Джинова» или правообладателей и не <br /> могут быть использованы
            без разрешения.
          </p>
        </section>

        <section>
          <h3>5. Ответственность сторон</h3>
          <p>
            5.1. ООО «Джинова» не несет ответственности за действия третьих лиц,
            нарушивших права пользователя или иного лица.
          </p>
          <p>
            5.2. В случае технических сбоев или недоступности Сайта ООО
            «Джинова» прилагает усилия к восстановлению его работоспособности,
            но не гарантирует постоянную <br /> бесперебойную работу.
          </p>
        </section>

        <section>
          <h3>6. Заключительные положения</h3>
          <p>
            6.1. Настоящее Соглашение вступает в силу с момента начала
            использования Сайта и действует бессрочно.
          </p>
          <p>
            6.2. Все споры, возникающие из настоящего Соглашения, подлежат
            рассмотрению в соответствии с законодательством Российской
            Федерации.
          </p>
        </section>

        <section>
          <h2>
            Политика в отношении обработки персональных данных ООО «Джинова»
          </h2>
          <h3>1. Общие положения</h3>
          <p>
            1.1. Настоящая Политика в отношении обработки персональных данных
            (далее — «Политика») определяет порядок обработки и защиты
            персональных данных <br /> пользователей, предоставляемых Обществу с
            ограниченной ответственностью «Джинова» (ОГРН, ИНН — при
            необходимости, далее — «Оператор») при использовании <br />{" "}
            интернет-сайта по адресу: [указать домен] (далее — «Сайт»).
          </p>
          <p>
            1.2. Политика составлена в соответствии с требованиями Федерального
            закона от 27.07.2006 № 152-ФЗ «О персональных данных» и иными
            нормативными актами РФ в <br /> области защиты персональных данных.
          </p>
          <p>
            1.3. Пользователь, предоставляя свои персональные данные при
            оформлении заказа или при использовании формы обратной связи на
            Сайте, подтверждает свое <br /> согласие на их обработку в
            соответствии с настоящей Политикой.
          </p>

          <h3>2. Персональные данные, подлежащие обработке</h3>
          <p>
            2.1. Оператор обрабатывает следующие категории персональных данных:
          </p>
          <p>
            <p>Для физических лиц:</p>
          </p>
          <ul>
            <li>Фамилия, имя (при наличии — отчество);</li>
            <li>контактный телефон;</li>
            <li>адрес электронной почты;</li>
            <li>город и адрес доставки.</li>
          </ul>
          <p>
            <p>Для юридических лиц:</p>
          </p>
          <ul>
            <li>наименование организации;</li>
            <li>ИНН, КПП;</li>
            <li>юридический адрес;</li>
            <li>контактное лицо;</li>
            <li>номер телефона, email;</li>
            <li>адрес доставки.</li>
          </ul>
          <p>
            2.2. Персональные данные не относятся к специальным категориям и не
            подлежат биометрической обработке.
          </p>

          <h3>3. Цели обработки персональных данных</h3>
          <p>3.1. Персональные данные обрабатываются в целях:</p>
          <ul style={{ listStyle: "none", paddingLeft: "0" }}>
            <li>оформления и доставки заказов;</li>
            <li>
              связи с пользователем по вопросам, связанным с заказами и
              запросами;
            </li>
            <li>исполнения обязательств по договорам купли-продажи;</li>
            <li>
              обработки обращений, направленных через форму обратной связи;
            </li>
            <li>соблюдения требований законодательства РФ.</li>
          </ul>

          <h3>4. Правовые основания обработки</h3>
          <p>
            4.1. Оператор осуществляет обработку персональных данных на
            основании:
          </p>
          <ul style={{ listStyle: "none", paddingLeft: "0" }}>
            <li>
              статьи 6 ФЗ № 152-ФЗ — согласие субъекта персональных данных;
            </li>
            <li>заключения и исполнения договора купли-продажи товаров;</li>
            <li>
              иных законных оснований, предусмотренных законодательством РФ.
            </li>
          </ul>

          <h3>5. Порядок обработки и хранения данных</h3>
          <p>
            5.1. Персональные данные обрабатываются с использованием средств
            автоматизации или без таковых, в соответствии с принципами:
          </p>
          <ul style={{ listStyle: "none", paddingLeft: "0" }}>
            <li>законности;</li>
            <li>ограничения обработки достижением конкретных целей;</li>
            <li>
              недопущения объединения баз, содержащих персональные данные,
              обработка которых осуществляется в разных целях;
            </li>
            <li>
              соответствия содержания и объема обрабатываемых персональных
              данных заявленным целям обработки;
            </li>
            <li>обеспечения точности и актуальности данных.</li>
          </ul>
          <p>
            5.2. Персональные данные хранятся не дольше, чем это необходимо для
            целей обработки.
          </p>

          <h3>6. Конфиденциальность и защита данных</h3>
          <p>
            6.1. Оператор принимает необходимые и достаточные организационные и
            технические меры для защиты персональных данных от неправомерного
            доступа, уничтожения, <br /> изменения, блокирования, копирования и
            распространения.
          </p>
          <p>
            6.2. Все сотрудники, допущенные к работе с персональными данными,
            несут ответственность за их сохранность.
          </p>

          <h3>7. Права субъекта персональных данных</h3>
          <p>Пользователь вправе:</p>
          <ul style={{ listStyle: "none", paddingLeft: "0" }}>
            <li>
              получить информацию о факте обработки и составе персональных
              данных;
            </li>
            <li>
              потребовать уточнения, блокировки или удаления своих данных;
            </li>
            <li>отозвать согласие на обработку данных;</li>
            <li>направить жалобу в Роскомнадзор при нарушении прав.</li>
          </ul>

          <h3>8. Заключительные положения</h3>
          <p>
            8.1. Оператор оставляет за собой право вносить изменения в настоящую
            Политику. Новая редакция вступает в силу с момента ее размещения на
            Сайте.
          </p>
          <p>
            <p style={{ marginBottom: "0" }}>
              Контактная информация Оператора:
            </p>
            <br />
            ООО «Джинова»
            <br />
            Тел.: +7 495 532-99-75
            <br />
            E-mail: hello@vellmar.ru
          </p>
        </section>
      </div>
      {isMobile ? <MobileFooter /> : <Footer />}
    </div>
  );
}

export default Legal;
